import actions from "actions";
import NavbarComponent from "components/Navbar/Navbar.jsx";
import constants from "constants";
import React, { Component, PropTypes } from "react";
import { connect } from "react-redux";
import { retrieveLinks } from "services/navLinks";
import { loadNotificationsCount } from "../../actions/users";

const {
  logout,
  showModal,
  searchWebinars,
  saveSearchedWebinars,
  searchWebinarsTerms,
  saveSearchedWebinarsTerms,
  login,
  hideModal,
} = actions;

const { MODAL_TYPE_NAVBAR } = constants;

const showMeetings = [
  "nurse_specialist",
  "practice_nurse",
  "nurse",
  "superhost",
  "admin",
];

class Navbar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: "",
      password: "",
      isLoading: false,
    };
  }

  componentDidMount() {
    this.props.role &&
      (showMeetings.includes(this.props.user.user_type) ||
        showMeetings.includes(this.props.role)) &&
      // showMeetings.includes(this.props.user.user_type) &&
      (() => {
        this.props.loadNotificationsCount();
        this.setReloadInterval();
      })();
  }

  componentWillUnmount() {
    this.clearReloadInterval();
  }

  componentDidUpdate(prev) {
    if (
      this.props.role &&
      prev.role !== this.props.role &&
      (showMeetings.includes(this.props.user.user_type) ||
        showMeetings.includes(this.props.role))
    ) {
      this.props.loadNotificationsCount();
    }
  }

  setReloadInterval = () => {
    this.reloadInterval = setInterval(() => {
      this.props.loadNotificationsCount();
      //30 min
    }, 1800000);
  };

  clearReloadInterval = () => {
    if (this.reloadInterval) {
      clearInterval(this.reloadInterval);
    }
  };

  handleChange = (e) => {
    const { value, name } = e.target;
    this.setState((prev) => ({ ...prev, [name]: value }));
  };

  handleSubmit = async (e) => {
    e.preventDefault();
    this.setState((prev) => ({ ...prev, isLoading: true }));
    try {
      await this.props.login(
        this.state.email.toLowerCase(),
        this.state.password
      );
    } catch (err) {
      console.log(err);
    }
    this.setState((prev) => ({ ...prev, isLoading: false }));
  };

  render() {
    const {
      logged,
      role,
      showMobileNav,
      hideModal,
      logout,
      user,
      push,
      q,
      notificationCount,
    } = this.props;

    const isModalOpen = this.props.modalType === MODAL_TYPE_NAVBAR;

    const toggleNavbar = isModalOpen ? hideModal : showMobileNav;

    return (
      <NavbarComponent
        q={q}
        links={retrieveLinks({
          logged,
          role,
          user,
          // isRepresentative: user.is_representative,
        })}
        push={push}
        isSearching={this.props.isSearching}
        pathname={this.props.pathname}
        logoutAction={logged ? logout : null}
        terms={this.props.terms}
        searchWebinarsTerms={this.props.searchWebinarsTerms}
        clearTerms={this.props.clearTerms}
        handleChange={this.handleChange}
        inputData={this.state}
        handleSubmitLogin={this.handleSubmit}
        toggleNavbar={toggleNavbar}
        notificationCount={notificationCount}
        {...{ user }}
      />
    );
  }
}

Navbar.PropTypes = {
  logged: PropTypes.boolean,
};

function mapStateToProps(state) {
  return {
    logged: !!(state.users.user && state.session && state.session.token),
    role: state.users.user.role,
    user: state.users.user,
    notificationCount: state.users.notificationsCount,
    terms: state.webinars.terms,
    isSearching: state.webinars.isSearching,
    modalType: state.modal.modalType,
  };
}

const mapDispatchToProps = (dispatch) => ({
  logout: () => dispatch(logout()),
  showMobileNav: () => dispatch(showModal(MODAL_TYPE_NAVBAR)),
  hideModal: () => dispatch(hideModal()),
  searchWebinarsTerms: (value) => dispatch(searchWebinarsTerms(value)),
  clearTerms: () => dispatch(saveSearchedWebinarsTerms([])),
  login: (email, password) => dispatch(login(email, password)),
  loadNotificationsCount: () => dispatch(loadNotificationsCount()),
});

export default connect(mapStateToProps, mapDispatchToProps)(Navbar);



// WEBPACK FOOTER //
// ./src/containers/Navbar/Navbar.js